import { ResultSet } from '@cubejs-client/core';

export const getSegments = (
  query: {
    resultSet: ResultSet<{
      [x: string]: string | number | boolean | null;
    }> | null;
  },
  index = 0,
) => {
  const segments = query.resultSet?.series()?.[index]?.series;
  const totalValue: number = segments?.reduce((p, c) => p + c.value, 0) ?? 0;

  return { segments, totalValue };
};
